import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import BrowserUtils from 'src/app/shared/utils/browser-utils';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-autorizacao-certificado-modal',
  templateUrl: './autorizacao-certificado-modal.component.html',
  styleUrls: ['./autorizacao-certificado-modal.component.scss']
})
export class AutorizacaoCertificadoModalComponent implements OnInit {

  urlAutorizacao = `${this.apiUrlService}/v1/cobranca-orquestrador-registro/cobrancas/redirect?url=${window.location.href}`;

  constructor(
    public dialogRef: MatDialogRef<AutorizacaoCertificadoModalComponent>,
  ) { }

  ngOnInit(): void {
  }

  get apiUrlService(): string {
    if (BrowserUtils.isOldFirefox()) {
      return environment.cdccorpApiURLService;
    }

    return environment.apiURLService;
  }

}
